<div class="page-wrapper">
    <div class="row no-gutter">
      <div class="col-sm-12 p-0">
        <app-header></app-header>
      </div>
      <div class="clearfix"></div>
      <div class="col-sm-2">
        <app-sidebar></app-sidebar>
      </div>
      <div class="col-sm-10 p-0">
        <div class="layout-wrap">
          <router-outlet></router-outlet>
          <div class="clearfix"></div>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="clearfix"></div>
      <div>
        <app-footer></app-footer>
      </div>
    </div>
  </div>
  
  